import type { DataGridProps } from '@cmg/data-grid';
import { ServerDataGrid } from '@cmg/data-grid';

import { useSideBarDef } from '../../../hooks/useSideBarDef';
import { investorFirmsColumnDefs } from '../../columns';
import type { InvestorFirmFragment } from '../../graphql/__generated__';
import { useInvestorFirmsGridDataSource } from './hooks/useInvestorFirmsGridDataSource';
import { INITIAL_INVESTOR_FIRMS_GRID_STATE } from './InvestorFirmsGrid.model';

const AUTO_SIZE_STRATEGY: DataGridProps<InvestorFirmFragment>['autoSizeStrategy'] = {
  type: 'fitGridWidth',
};

export function InvestorFirmsGrid() {
  const sideBar = useSideBarDef();
  const dataSource = useInvestorFirmsGridDataSource();
  return (
    <ServerDataGrid<InvestorFirmFragment>
      serverSideDatasource={dataSource}
      columnDefs={investorFirmsColumnDefs}
      sideBar={sideBar}
      autoSizeStrategy={AUTO_SIZE_STRATEGY}
      initialState={INITIAL_INVESTOR_FIRMS_GRID_STATE}
    />
  );
}
